// extracted by mini-css-extract-plugin
module.exports = {"video-container":"VideoGroup_video-container__QSjtP","video-info":"VideoGroup_video-info__XYp2K"};